import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import PrivateRouter from "./Routers/PrivateRouter";
import PublicRouter from "./Routers/PublicRouter";
import routes from "./routes";
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
// const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

class App extends Component {
  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <PublicRouter
              exact
              path="/"
              name="Login Page"
              // render={(props) => <Login {...props} />}
              component={Login}
            />
            <PublicRouter
              exact
              path="/login"
              name="Login Page"
              // render={(props) => <Login {...props} />}
              component={Login}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            {/* <Route path="/" name="Home" render={(props) => <DefaultLayout {...props} />} /> */}
            {routes.map((route, idx) => {
              return (
                route &&
                route.component && (
                  <PrivateRouter
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    component={TheLayout}
                  />
                )
              );
            })}
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
